import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@material-ui/core";
import t from "../../../languages/pl";
import LineScatterChart from './LineScatterChart';
import Status from "../../Common/BulletStatus";
import { setGradeColor } from "../../../utils/helpers";
import { getLastAverage } from './../../../utils/helpers';

const useStyles = makeStyles(() => ({
    content: {
        overflow: "hidden",
        textAlign: "center"
    }
}));

const EcoChartDialog = ({open, onClose, data, carData, isCar,driverData, isDriver}) => {
    const classes = useStyles();

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="md"
        >
            <DialogTitle>
                {t.ecoChart} {isCar && carData !== null ? carData.brand + " " + carData.model + " " + carData.registrationNo :
                    isDriver && driverData ? driverData.kierowca_nazwa
                        : null
                }
            </DialogTitle>
            <DialogContent className={classes.content}>
                <Typography variant="subtitle2">
                    {t.averageEcoGrade}&nbsp;
                    <Status background={setGradeColor(getLastAverage(data))}>{getLastAverage(data)}</Status>
                </Typography>
                <LineScatterChart data={data}/>
            </DialogContent>
            <DialogActions>
                <Button
                    variant="contained"
                    color="secondary"
                    onClick={onClose}
                >
                    {t.close}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

EcoChartDialog.propTypes = {
    data: PropTypes.array,
    carData: PropTypes.object,
    open: PropTypes.bool,
    isCar: PropTypes.bool,
    driverData: PropTypes.object,
    isDriver: PropTypes.bool,
    onClose: PropTypes.func,
};

export default (EcoChartDialog);
